import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Calculator"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
  selector: 'app-icon-calculator',
  templateUrl: './icon-calculator.component.html',
  styleUrls: ['./icon-calculator.component.scss'],
  standalone: false,
})
export class IconCalculatorComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
